export const LOCALE_CODE = {
  UNITED_STATES_ENGLISH: 'en-US'
};
